import { dataHooks } from '../../../../../libs/dataHooks';

export const suggestionsListItemDataHooks = dataHooks<{
  root: { selected: boolean };
  text: {};
  categoryLabel: {};
}>('suggestionsListItem');
